import { defineAction, object, boolean, enumerated, string } from '~/prix'
import fetchStreetsFromIbgeAction from './fetchStreetsFromIbge.action.json'

const fetchStreetsFromIbgeDefinition = defineAction({
  ...fetchStreetsFromIbgeAction,
  input: object({
    level: enumerated({
      macroRegion: 'macroRegion',
      mesoRegion: 'mesoRegion',
      microRegion: 'microRegion',
      state: 'state',
      city: 'city',
    }).isOptional(),
    ibgeCodes: string(),
  }),
  output: object({}),
})

export default fetchStreetsFromIbgeDefinition
